import {Select, SelectProps} from "@mantine/core";
import {States} from "./States";

interface Props extends Omit<SelectProps, "data"> {

}

function MalaysiaState(props: Props) {

    function serializeStates() {
        return States.map((state) => ({value: state.code, label: `${state.name}`}))
    }

    return (
        <Select {...props} data={serializeStates()}/>
    )

}

export default MalaysiaState;